import get from 'lodash/get';
import pick from 'lodash/pick';
import BaseError from './BaseError';
const requestParamsToLog = ['method', 'url', 'params', 'timeout'];
const responseParamsToLog = ['data', 'status', 'statusText'];
export default class ApiError extends BaseError {
    constructor(apiDetails) {
        super(apiDetails.message || get(apiDetails, 'response.statusText'));
        Object.setPrototypeOf(this, ApiError.prototype);
        this.name = 'ApiError';
        const request = get(apiDetails, 'response.config') || apiDetails.config;
        this.request = request && pick(request, requestParamsToLog);
        this.response =
            apiDetails.response && pick(apiDetails.response, responseParamsToLog);
        if (!apiDetails.doNotIncludeStatus && apiDetails.response) {
            this.statusCode = apiDetails.response.status;
        }
    }
}
